import { ContextModalProps } from '@mantine/modals'
import NewShortageOrderForm from 'components/shortage/NewShortageOrderForm'
import { useOrderShortages } from 'hooks/shortage'
import { NewShortageOrder } from 'types/shortage'

export default function AddShortageOrderModal({ context, id }: ContextModalProps) {
  const orderShortages = useOrderShortages()

  return (
    <NewShortageOrderForm
      onSubmit={async (values: NewShortageOrder) => {
        await orderShortages.mutateAsync(values)
      }}
      onCancel={() => context.closeModal(id)}
    />
  )
}
